import Swal from 'sweetalert2';

/**
 * Gets the current color scheme based on system settings and app dark mode
 */
const getColorScheme = (): 'light' | 'dark' => {
  // Check if document has dark class (app dark mode)
  if (document.documentElement.classList.contains('dark')) {
    return 'dark';
  }
  // Check system preference
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
};

/**
 * Handles delete confirmation and execution using SweetAlert2
 * @param deleteApi - Async function that performs the delete operation
 * @param customText - Optional custom text to display (defaults to "You won't be able to revert this!")
 */
export const handleDelete = async (deleteApi: () => Promise<void>, customText?: string) => {
  const isDark = getColorScheme() === 'dark';
  const popupClass = isDark ? 'swal2-compact swal2-dark' : 'swal2-compact';
  
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: customText || "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
    width: '380px',
    padding: '1.25rem',
    customClass: {
      popup: popupClass,
      title: 'swal2-title-compact',
      htmlContainer: 'swal2-html-compact',
      confirmButton: 'swal2-confirm-compact',
      cancelButton: 'swal2-cancel-compact',
    }
  });

  if (result.isConfirmed) {
    try {
      await deleteApi();
      await Swal.fire({
        title: 'Deleted!',
        text: 'Your item has been deleted.',
        icon: 'success',
        width: '380px',
        padding: '1.25rem',
        customClass: {
          popup: popupClass,
          title: 'swal2-title-compact',
          htmlContainer: 'swal2-html-compact',
          confirmButton: 'swal2-confirm-compact',
        }
      });
    } catch (error) {
      console.error('Error deleting:', error);
      await Swal.fire({
        title: 'Error!',
        text: 'Failed to delete item.',
        icon: 'error',
        width: '380px',
        padding: '1.25rem',
        customClass: {
          popup: popupClass,
          title: 'swal2-title-compact',
          htmlContainer: 'swal2-html-compact',
          confirmButton: 'swal2-confirm-compact',
        }
      });
    }
  }
};

